import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import styles from "../styles";
import NavIcon, { NavIconName } from "./icons";

interface LeftSideBarIconProps {
  name: string | JSX.Element;
  isActive: boolean;
  onClick: () => void;
  icon: NavIconName;
  link: string;
  locked?: boolean;
  onLockedClick?: () => void;
}

function LeftSideBarIcon({
  name,
  icon,
  isActive,
  onClick,
  link,
  locked = false,
  onLockedClick,
}: LeftSideBarIconProps) {
  const content = (
    <Box
      display="flex"
      alignItems={"center"}
      flexDirection="column"
      sx={[
        styles.button,
        isActive ? styles.active : styles.inactiveText,
        locked ? { opacity: 0.4 } : {},
      ]}
      onClick={locked ? onLockedClick : onClick}
    >
      <NavIcon name={locked ? "lock" : icon} size={18} />
      <Typography textAlign="center" variant="caption" sx={styles.iconText}>
        {name}
      </Typography>
    </Box>
  );

  if (locked) {
    return <Box sx={styles.link}>{content}</Box>;
  }

  return (
    <Link to={link} style={styles.link}>
      {content}
    </Link>
  );
}

export default LeftSideBarIcon;
